<template>
  <section
    v-if="items.length"
    id="related-lpus"
    data-qa="lpu_related_clinics"
    class="d-flex flex-column"
    :class="isMobile ? 'ga-5' : 'ga-6'"
  >
    <h2
      data-qa="lpu_related_clinics_title"
      class="text--text"
      :class="isMobile ? 'text-h6' : 'text-h5'"
    >
      {{ tStatic('Связанные клиники') }}
    </h2>

    <div>
      <RelatedClinicItem
        v-for="(clinic, index) in items"
        :key="clinic.url || `${clinic.name}-${index}`"
        :clinic="clinic"
        :is-striped="index % 2 === 0"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import useIsMobile from 'src/composables/useIsMobile'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { RelatedLpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuRelatedClinics/types'
import RelatedClinicItem from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuRelatedClinics/components/RelatedClinicItem.vue'

defineProps<{
  items: RelatedLpu[]
}>()

const isMobile = useIsMobile()
</script>
